import { render } from "./CustomizationPage.vue?vue&type=template&id=10314a2f&scoped=true"
import script from "./CustomizationPage.vue?vue&type=script&lang=js"
export * from "./CustomizationPage.vue?vue&type=script&lang=js"

import "./CustomizationPage.vue?vue&type=style&index=0&id=10314a2f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10314a2f"]])

export default __exports__